<template>
    <div>
        <div class="down_bg">
            <div class="down_logo">
                <img src="../../assets/img/down_logo.png" alt="">
            </div>
            <div class="down_but" @click="doDownLoad(0)">
                <img src="../../assets/img/down_android.png" alt="">
                <span>Android版下载</span>
            </div>
            <div class="down_but" @click="doDownLoad(1)">
                <img src="../../assets/img/down_ios.png" alt="">
                <span>iPhone版下载</span>
            </div>
        </div>
        <template v-if="isShow">
            <div class="down_guide" @click="doHide"><img src="../../assets/img/down_guide.png" alt="点击右上角点击用浏览器打开下载/安装"></div>
            <div class="tk_bg" @click="doHide"></div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isShow: false,
                isWeixin: false
            }
        },
        created () {
            document.title = "下载富裕钱包APP";
            this.is_weixn();
        },
        methods: {
            doDownLoad(index) {
                if(index == 0){//安卓下载
                    if(this.isWeixin){//如果是微信浏览器那么弹出引导页
                        this.isShow = true;
                    }else{//否则展示下载按钮
                        this.isShow = false;
                        window.location.href = "https://app-client.verajft.com/app/download/Wallet.apk"
                    }
                }else{//苹果下载
                    window.location.href = "https://apps.apple.com/cn/app/%E5%AF%8C%E8%A3%95%E9%92%B1%E5%8C%85/id1500407303";
                }
            },
            // 判断是不是微信浏览器
            is_weixn() {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    this.isWeixin = true;
                } else {
                    this.isWeixin = false;
                }
            },
            //隐藏引导页
            doHide(){
                this.isShow = false;
            }
        },
    }
</script>

<style lang="scss" scoped>
.down_bg{
    width: 100%;
    height: 100%;
    position: absolute;
    background: url("../../assets/img/down_bg.png") no-repeat;
    background-size: 100% 100%;
    top: 0;
    left: 0;
    z-index: 0;
}
.down_logo{
    width: 256px;
    margin: 110px auto 96px;
}
.down_logo img{
    width: 100%;
    height: 100%;
    display: block;
}
.down_but{
    width: 290px;
    height: 50px;
    border: 1px solid #fff;
    border-radius: 7px;
    margin: 28px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.down_but img{
    width: 27px;
    height: 33px;
    margin-right: 15px;
}
.down_but span{
    color: #fff;
    font-size: 17px;
}
.tk_bg{
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.8;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
}
.down_guide{
    width: 70%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3
}
.down_guide img{
    width: 100%;
}
</style>